import { Button, Col, Form, Input, Row, Typography, DatePicker } from "antd";
import React, { Fragment, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
	addAnnouncement,
	loadAllAnnouncement,
} from "../../redux/rtk/features/announcement/announcementSlice";
import moment from 'moment';

const AddAnnouncement = ({ drawer, editData, setEditData, onCancel }) => {
	const { loading } = useSelector((state) => state.announcement);
	const dispatch = useDispatch();
	const { Title } = Typography;
	const [form] = Form.useForm();
	
	// Set form fields when editData changes
	useEffect(() => {
		if (editData) {
			form.setFieldsValue({
				AnnouncementText: editData.AnnouncementText,
				AnnouncementStartDate: editData.AnnouncementStartDate ? moment(editData.AnnouncementStartDate) : null,
				AnnouncementEndDate: editData.AnnouncementEndDate ? moment(editData.AnnouncementEndDate) : null,
			});
		} else {
			form.resetFields();
		}
	}, [editData, form]);

	useEffect(() => {
		dispatch(loadAllAnnouncement());
	}, []);

	const onFinish = async (values) => {
		// Prepare data for API
		const data = {
			AnnouncementId: editData ? editData.AnnouncementId : 0,
			AnnouncementText: values.AnnouncementText,
			AnnouncementStartDate: values.AnnouncementStartDate ? values.AnnouncementStartDate.format('YYYY-MM-DD') : null,
			AnnouncementEndDate: values.AnnouncementEndDate ? values.AnnouncementEndDate.format('YYYY-MM-DD') : null,
			DataStatus: 1
		};

		const resp = await dispatch(addAnnouncement(data));

		if (resp.payload.message === "success") {
			form.resetFields();
			if (setEditData) setEditData(null);
			dispatch(loadAllAnnouncement());
			toast.success(editData ? "Announcement updated successfully!" : "Announcement added successfully!");
			onCancel?.();
		}
	};

	const onFinishFailed = (errorInfo) => {
		toast.warning(editData ? "Failed to update announcement" : "Failed to add announcement");
	};

	const cancelEdit = () => {
		form.resetFields();
		if (setEditData) setEditData(null);
	};

	return (
		<div className="add-announcement-wrapper">
			<div className='column-design border rounded card-custom'>
				<Title level={4} className='m-2 mt-2 mb-5 text-center'>
					{editData ? 'Edit Announcement' : 'Add Announcement'}
				</Title>
				<Form
					form={form}
					style={{ marginBottom: "40px" }}
					eventKey='announcement-form'
					name='basic'
					labelCol={{
						span: 6,
					}}
					wrapperCol={{
						span: 12,
					}}
					onFinish={onFinish}
					onFinishFailed={onFinishFailed}
					autoComplete='off'>
					<div>
						<Form.Item
							style={{ marginBottom: "10px" }}
							label='Announcement Text'
							name='AnnouncementText'
							rules={[
								{
									required: true,
									message: "Please input announcement text!",
								},
							]}>
							<Input.TextArea placeholder='Enter announcement text' />
						</Form.Item>

						<Form.Item
							style={{ marginBottom: "10px" }}
							label='Start Date'
							name='AnnouncementStartDate'
							rules={[
								{
									required: true,
									message: "Please select start date!",
								},
							]}>
							<DatePicker style={{ width: '100%' }} />
						</Form.Item>

						<Form.Item
							style={{ marginBottom: "20px" }}
							label='End Date'
							name='AnnouncementEndDate'>
							<DatePicker style={{ width: '100%' }} />
						</Form.Item>

						<Form.Item
							style={{ marginBottom: "10px" }}
							wrapperCol={{
								offset: 6,
								span: 12,
							}}>
							<Button
								type='primary'
								size='large'
								block
								htmlType='submit'
								loading={loading}>
								{editData ? 'Update Announcement' : 'Add Announcement'}
							</Button>
							
							{editData && (
								<Button
									type='default'
									size='large'
									block
									onClick={cancelEdit}
									className='mt-2'>
									Cancel
								</Button>
							)}
						</Form.Item>
					</div>
				</Form>
			</div>
		</div>
	);
};

export default AddAnnouncement;